export enum DisplayType{
    LIST=0,
    TREELIST=1
}